// extracted by mini-css-extract-plugin
export var createdDate = "_jx-1";
export var divider = "_jx-2";
export var headerDivider = "_jx-3";
export var messagesCard = "_jx-0";
export var messagesContainer = "_jx-7";
export var messagesContainerWrapper = "_jx-4";
export var pointerCapturingButtonBoxes = "_jx-a";
export var showLeftPanelButton = "_jx-9";
export var showMoreButton = "_jx-c";
export var showMoreButtonContainer = "_jx-b";
export var summaryTitle = "_jx-6";
export var systemMessageCardWrapper = "_jx-d";
export var topButtons = "_jx-8";
export var withPadding = "_jx-5";